import * as React from 'react';
import { useState, useEffect } from 'react';
import { Image as ImageType } from '../../../typings';
import 'lazysizes';
import 'lazysizes/plugins/attrchange/ls.attrchange';
import './styles.scss';

const defaultWidths = ['400', '800', '1200', '2400', '4000'];

const aspectRatioMap: Record<string, number> = {
  '2x1': 0.5,
  '16x9': 0.5625,
  '3x2': 0.667,
  '4x3': 0.75,
  '1x1': 1,
  '4x5': 1.2,
  '2x3': 1.5,
};

interface ImageObjectProps {
  image: ImageType;
  widthSizes?: string[];
  isDarkened?: boolean;
  useFocalPoint?: boolean;
  fitType?: 'contain' | 'cover'
  isLoaded?: () => void;
  noAnimate?: boolean;
  aspectRatio?: string;
}

interface FocalStyle {
  objectPosition: string;
}

const ImageObject = ({
  image,
  widthSizes = defaultWidths,
  aspectRatio,
  isDarkened = false,
  useFocalPoint = true,
  fitType = 'cover',
  isLoaded,
  noAnimate,
}: ImageObjectProps) => {
  const [focalPoint, setFocalPoint] = useState<FocalStyle>();
  const [srcset, setSrcset] = useState<string>();

  useEffect(() => {
    if (image.focalPoint) {
      // @ts-ignore
      const xPercentile = (image.focalPoint.x / image.file.details?.image?.width) * 100;
      // @ts-ignore
      const yPercentile = (image.focalPoint.y / image.file.details?.image?.height) * 100;
      setFocalPoint({
        objectPosition: `${xPercentile}% ${yPercentile}%`,
      });
    }

    const src = widthSizes
      .map((size: string, index: number) => `${image.file.url}?fit=thumb&fl=progressive&w=${size}&h=${aspectRatio ? Math.ceil(Number(widthSizes[index]) * aspectRatioMap[aspectRatio]) : ''} ${size}w`);

    setSrcset(src.join(','));
  }, [image]);

  const classes = [
    'image-object',
    `image-object--${fitType}`,
    'lazyload',
  ];
  if (isDarkened) {
    classes.push('has-opacity');
  }
  if (noAnimate) {
    classes.push('image-object--no-animate');
  }

  return (
    <img
      onLoad={() => isLoaded?.()}
      data-sizes="auto"
      data-srcset={srcset}
      data-src={`${image.file.url}?fit=thumb&fl=progressive&w=${widthSizes[0]}&h=${aspectRatio ? Math.ceil(Number(widthSizes[0]) * aspectRatioMap[aspectRatio]) : ''}`}
      className={classes.join(' ')}
      alt={image.title ? image.title : 'image with no description'}
      style={useFocalPoint ? focalPoint : undefined}
    />
  );
};

export default ImageObject;
